import React from "react";
import { Grid } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import AccountHealth from "./Pages/AccountHealth/AccountHealth";
import QuarterlyBusinessReview from "./Pages/QuarterlyBusinessReview/QuarterlyBusinessReview";
import QBROutReach from "./Pages/QBRExecutingOutReach/QBRExecutingOutReach";
import QBRF2F from "./Pages/QBRF2FMeetings/QBRF2FMeetings";
import QBROnBoard from "./Pages/QBROnBoardEvents/QBROnBoardEvents";
import RenewalsCompleted from "./Pages/RenewalsCompleted/RenewalsCompleted";
import RenewalsOverDue from "./Pages/RenewalsOverDue/RenewalsOverDue";
import GetWellSummary from "./Pages/GetWellSummary/GetWellSummary";
import ChangeOverTime from "./Pages/ChangeOverTime/ChangeOverTime";
import AccountHealthByTeam from "./Pages/AccountHealthByTeam/AccountHealthByTeam";
import RenewalsPriceIncrease from "./Pages/RenewalsPriceIncrease/RenewalsPriceIncrease";
import ChurnAnalysis from "./Pages/ChurnAnalysis/ChurnAnalysis";

const styles = (theme) => ({
  dashOuter: {
    display: "flex",
    flexGrow: 1,
    margin: "auto",
  },
  dashInner: {
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
  },
  graph1: {
    flexGrow: 1,
    height: 250,
    margin: 10,
  },
});

const CustomerSuccessRoutes = (props) => {
  const { classes } = props;
  return (
    <>
      {props.location === "Account Health - Current Status" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12}>
            <AccountHealth />
          </Grid>
        </Grid>
      )}
      {props.location === "QBRs Completed" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12}>
            <QuarterlyBusinessReview />
          </Grid>
        </Grid>
      )}
      {props.location === "Executive Outreach Events" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12}>
            <QBROutReach />
          </Grid>
        </Grid>
      )}
      {props.location === "F2F Meetings" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12}>
            <QBRF2F />
          </Grid>
        </Grid>
      )}
      {props.location === "Onboarding Events" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12}>
            <QBROnBoard />
          </Grid>
        </Grid>
      )}
      {props.location === "Renewals Summary" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12}>
            <RenewalsCompleted />
          </Grid>
        </Grid>
      )}
      {props.location === "Renewals Summary - Price Increase" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12}>
            <RenewalsPriceIncrease />
          </Grid>
        </Grid>
      )}
      {props.location === "Account Health - Get Well Summary" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12}>
            <GetWellSummary />
          </Grid>
        </Grid>
      )}
      {props.location === "Account Health - Change over time" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12}>
            <ChangeOverTime />
          </Grid>
        </Grid>
      )}
      {props.location === "Account Health - By Teams" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12}>
            <AccountHealthByTeam />
          </Grid>
        </Grid>
      )}
      {props.location === "Customer Churn Analysis" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <ChurnAnalysis />
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default withStyles(styles)(CustomerSuccessRoutes);
